import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FraudDisclosure } from '../model/fraud-disclosure';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class FraudDisclosureService {
    public url: string = environment.blobStorageBaseURL;

    constructor(private _http: HttpClient) {}

    getFraudDisclosure(): Observable<FraudDisclosure[]> {
        const ts = new Date().getTime();
        return this._http.get<any>(
            this.url + '/data/fraudDisclosures.json?ts=' + ts
        );
    }
}
